import * as yup from 'yup';


export const operadoraFormSchema = yup.object({
  nombre: yup.string().required('El campo nombre es requerido'),
});
